"use strict";

angular
  .module(ApplicationConfiguration.applicationModuleName)
  .controller(
    "controlPanelCtrl",
    function (
      $scope,
      $rootScope,
      $window,
      $state,
      $localStorage,
      settings,
      permissionService,
      tools,
      apiSettings,
      $document,
      Alerts,
      $sce,
      $http
    ) {
      var vm = this;
      vm.permissions = permissionService;

      vm.projectModule = config.projectModule;


      switch (vm.projectModule) {
        case "SWFlow":
          $(".auth-img").prepend(
            '<img src="/images/logo-sherwin-williams-swflow.png" alt="SWFLOW" />'
          );
          $(".powered-img").prepend(
            '<img src="/Images/img-powered.svg" alt="Powered by Astéria" />'
          );
          break;
        case "Colors":
          $("body").addClass("a-sua-cor");
          $(".auth-img").prepend(
            '<img src="/images/logo-sw-colorsnap.png" alt="A Sua Cor" />'
          );
          $(".powered-img").prepend(
            '<img src="/Images/img-asuacor-powered.svg" alt="Powered by Astéria" />'
          );
          break;
      }


      // Server settings
      $scope.globalConfig = $window.config;

      // Menu size
      $scope.resize = function () {
        var h = $window.innerHeight;
        var t1 = $(".sidebar .user").outerHeight(true);
        var t2 = $(".sidebar .signature").outerHeight(true);

        $(".menu").height(h - t1 - t2);
      };

      $scope.resize();

      // Scroll para o topo da página, quando houver navegação entre as views do angular
      $rootScope.$on("$stateChangeSuccess", function () {
        document.body.scrollTop = document.documentElement.scrollTop = 0;

        // Caso seja um dispositivo Mobile, quando houver navegação entre as views, forçamos para que o menu feche
        if (tools.isMobile()) vm.closeMenu();
      });

      angular.element($window).bind("resize", $scope.resize);

      // Summernote configuration
      $scope.smConfig = {
        height: 300,
        lang: "pt-BR",
        toolbar: [
          // ['style', ['style']],
          // ['fontname', ['fontname']],
          ["format", ["bold", "italic", "underline", "clear"]],
          ["font", ["strikethrough", "superscript", "subscript"]],
          // ['picture', ['picture']],
          ["link", ["link"]],
          ["para", ["ul", "ol"]],
          ["codeview", ["codeview"]],
          ["fullscreen", ["fullscreen"]],
        ],
        callbacks: {
          onPaste: function (e) {
            var bufferText = (
              (e.originalEvent || e).clipboardData || window.clipboardData
            ).getData("Text");

            e.preventDefault();

            // Firefox fix
            setTimeout(function () {
              document.execCommand("insertText", false, bufferText);
            }, 10);
          },
        },
      };

      //// Flow
      //$scope.flowOptions = {
      //	singleFile: true,
      //	testChunks: false,
      //	headers: {
      //		'Authorization': 'Bearer ' + $localStorage.authorizationData.token
      //	}
      //};

      // Configurações
      $scope.settings = settings || {};

      // Methods
      vm.toggleMenu = function () {
        vm.menuOpened = !vm.menuOpened;
      };

      vm.closeMenu = function () {
        vm.menuOpened = false;
      };

      vm.insertNew = function (url, enumContentArea, routeData) {
        angular.extend({}, routeData);

        if (enumContentArea) {
          angular.extend(routeData, { enumContentArea: enumContentArea });
        }

        $state.go(url, routeData);
      };

      vm.quit = function () {
        settings.signOut();
        $state.go("login");
      };

      // Definindo o título da página
      $scope.pageTitle = apiSettings.title;
      $scope.themeColor = apiSettings.themeColor;
      $scope.broswerConfig = apiSettings.broswerConfig;
      $scope.pageTitfaviconUrlApplele = apiSettings.faviconUrlApple;
      $scope.faviconUrl32 = apiSettings.faviconUrl32;
      $scope.faviconUrl16 = apiSettings.faviconUrl16;
      $scope.faviconUrl = apiSettings.faviconUrl;
      $scope.scriptUrl = apiSettings.chatHubsUrl;

      var script = $document[0].createElement("script");
      script.src = $sce.trustAsResourceUrl(apiSettings.chatHubsUrl);
      $document[0].body.appendChild(script);
    }
  );
